// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Utils
import { getElementId } from '../../../common/elements/utils/elementPropertyUtils';
import { getNewTransactionId } from '../../utils/undoRedo/undoRedoTransactionManager';

// Actions
import { elementUnsuggestFeature } from './suggestionActions';

// Hooks
import { useTranslator } from '../../components/i18n/useTranslator';

// Components
import ElementTip from './ElementTip';
import AnchorButton from '../../components/buttons/AnchorButton';

const mapDispatchToProps = (dispatch) => ({
    dispatchUnsuggestFeature: ({ id, suggestion }) => dispatch(elementUnsuggestFeature({ id, feature: suggestion })),
});

class FeatureSuggestionContent extends React.Component {
    onConfirm = (event) => {
        const { dispatchUnsuggestFeature, suggestion, element, onConfirm } = this.props;

        const transactionId = getNewTransactionId();
        dispatchUnsuggestFeature({ id: getElementId(element), suggestion, transactionId });

        onConfirm(event, transactionId);
    };

    onDismiss = (event) => {
        const { dispatchUnsuggestFeature, suggestion, element, onDismiss } = this.props;

        event.preventDefault();
        event.stopPropagation();

        dispatchUnsuggestFeature({ id: getElementId(element), suggestion });

        onDismiss(event);
    };

    render() {
        const { question, yesLabel, noThanksLabel } = this.props;

        return (
            <ElementTip className="FeatureSuggestion" {...this.props}>
                <span className="question">{question}</span>
                <AnchorButton onClickFn={this.onConfirm}>{yesLabel}</AnchorButton>
                <AnchorButton onClickFn={this.onDismiss}>{noThanksLabel}</AnchorButton>
            </ElementTip>
        );
    }
}

FeatureSuggestionContent.propTypes = {
    question: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    yesLabel: PropTypes.string.isRequired,
    noThanksLabel: PropTypes.string.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onDismiss: PropTypes.func.isRequired,
    added: PropTypes.bool,
    icon: PropTypes.object,

    suggestion: PropTypes.string,
    element: PropTypes.object,
    dispatchUnsuggestFeature: PropTypes.func,
};

const ConnectedFeatureSuggestionContent = connect(null, mapDispatchToProps)(FeatureSuggestionContent);

/**
 * Wrapper component that uses useTranslation hook to provide translated button labels
 */
const FeatureSuggestion = (props) => {
    const translate = useTranslator('elements');

    const yesLabel = translate('featureSuggestions.yes', 'Yes');
    const noThanksLabel = translate('featureSuggestions.noThanks', 'No thanks');

    return (
        <ConnectedFeatureSuggestionContent
            {...props}
            yesLabel={yesLabel}
            noThanksLabel={noThanksLabel}
        />
    );
};

FeatureSuggestion.propTypes = {
    question: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    onConfirm: PropTypes.func.isRequired,
    onDismiss: PropTypes.func.isRequired,
    added: PropTypes.bool,
    icon: PropTypes.object,

    suggestion: PropTypes.string,
    element: PropTypes.object,
};

export default FeatureSuggestion;
